/**
 * @desc - swiper
 * @link - http://idangero.us/swiper/
 */
$(function(){
  var swiper = new Swiper('.swiper-container', {
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    pagination: '.swiper-pagination',
    paginationClickable: true,
    parallax: true,
    speed: 600,
    loop: true,
  });
});